const Footer = () =>{
  return (
    
    <footer>
        <p>
        Created by <a href="https://michelledcodes.com/">Michelle</a>, <a href="https://jessicahandrahan.ca/">Jessica</a> and <a href="https://jasminelo.com/">Jasmine</a> at Juno College 2023©
        </p>

    </footer>
  )
}

export default Footer